import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
const submenu = document.querySelectorAll('[js-submenu]')
const item = document.querySelectorAll('[js-submenu-item]')
const menu = document.querySelector('.menu-primary-wrap')
const menuBtn = document.querySelector('.btn-mobile')
const submenuLabel = document.querySelectorAll('.menu-mobile-has-child')

const isMobile = window.innerWidth < 1024

if (submenu.length > 0) {
  if (!isMobile) {
    item.forEach((btn, index) => {
      btn.addEventListener('mouseover', () => {
        submenu[index].style.display = 'block'
        submenu[index].classList.add('is-active')
        btn.classList.add('is-active')
      })

      btn.addEventListener('mouseout', () => {
        submenu[index].style.display = 'none'
        btn.classList.remove('is-active')
        submenu[index].classList.remove('is-active')

      })
    })
  } else {
    menuBtn.addEventListener('click', () => {
      disableBodyScroll(document.documentElement);
      disableBodyScroll(document.body);
      document.body.style.overflow = 'hidden'
      document.body.style.height = '100%'

      menuBtn.classList.toggle('is-open')
      menu.classList.toggle('is-open')

      if (menuBtn.classList.contains('is-open')) {
        disableBodyScroll(document.documentElement);
        disableBodyScroll(document.body);
      } else {
        clearAllBodyScrollLocks()
        document.body.style.overflow = ''
        document.body.style.height = ''
      }
    })
  }

  if (submenuLabel.length > 0) {
    submenuLabel.forEach((btn, index) => {
      btn.addEventListener('click', () => {
        console.log(index, submenu, submenu[index])
        submenu[index].classList.toggle('is-active')
        btn.classList.toggle('is-active')
      })
    })
  }
}